import * as React from "react";
import { IconComponent } from "../../../ui";

/** Icon then label, as the history's own section tabs show them. */
export const TabLabel: React.FC<{ Icon: IconComponent; label: string }> = ({ Icon, label }) => (
  <span className="flex items-center justify-center gap-1 whitespace-nowrap">
    <Icon style={{ fontSize: "1rem", flexShrink: 0 }} />
    {label}
  </span>
);
